export default __webpack_public_path__ + "static/media/nasa-prica-photo-7.7a2ec59f.jpg";